import Vue from 'vue';

export default {
  namespaced: true,

  state: {
    activateTutorial: false,
  },

  getters: {
    getActivateTutorial(state) {
      return state.activateTutorial;
    },

  },

  mutations: {
    SET_ACTIVATE_TUTORIAL(state, payload) {
      Vue.set(state, 'activateTutorial', payload);
    },
  },
};
